/**
 * ChangelogPage — human-readable release notes, linked from the sidebar
 * footer. Newest first. Add an entry per meaningful release.
 */
const ENTRIES: { version: string; date: string; items: string[] }[] = [
  {
    version: '1.1.0',
    date: 'June 2026',
    items: [
      'New look: Ventin branding, sidebar navigation, and a site footer',
      'Your profile page — view your account details and change your password',
      'Faster, more reliable hosting on our new infrastructure',
      'Fixed: ticket details now load correctly in the client portal',
    ],
  },
  {
    version: '1.0.0',
    date: 'April 2026',
    items: [
      'Initial release: ticketing, real-time time tracking, 20-minute increment billing',
      'Client dashboard with live usage and monthly reports (PDF + CSV)',
      'Email-to-ticket support and knowledgebase',
    ],
  },
];

export default function ChangelogPage() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-8">
      <h2 className="text-2xl font-semibold mb-1">Changelog</h2>
      <p className="text-sm text-muted-foreground mb-8">What's new in Ventin Support.</p>
      <div className="space-y-8">
        {ENTRIES.map((entry) => (
          <section key={entry.version} className="rounded-lg border bg-card p-6">
            <div className="flex items-baseline gap-3 mb-3">
              <h3 className="text-lg font-semibold">v{entry.version}</h3>
              <span className="text-sm text-muted-foreground">{entry.date}</span>
            </div>
            <ul className="list-disc pl-5 space-y-1.5 text-sm">
              {entry.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
}
